module.exports = __webpack_public_path__ + "static/media/chevrons-right.99ae3420.svg";